module.exports = __webpack_public_path__ + "img/stock6.b6f2b572.png";